import React from 'react';
import { ImageIcon, MegaphoneIcon, RocketIcon, FileContractIcon, LinkIcon, TagIcon, BoxIcon } from '@revfluence/fresh-icons/regular/esm';
import aspireIcon from '@frontend/app/assets/svgs/aspire_icon.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faAddressCard, faBoxCircleCheck, faCalendarImage, faCircleDollar, faEnvelope, faImage, faMegaphone, faPaintbrushPencil, faPhotoFilm, faRocket, faTags } from '@fortawesome/pro-duotone-svg-icons';
import { faAddressCard, faBell, faCalendar, faCircleDollarToSlot, faEnvelope, faImage, faPaintbrush, faPhotoFilm, faRocket, faSquareCheck, faTags } from '@fortawesome/free-solid-svg-icons';
import { TemplateName } from '../TemplatesPage/TemplatesPage';
import { CustomProjectTemplateName, WorkletSpecUri } from '../constants';
import { TWorkletWithoutTypename } from './CampaignContext';

export const getCampaignDescription = (templateName: string) => {
  switch (templateName) {
    case TemplateName.ProductGifting:
      return 'Spread the word of your latest product.';
    case TemplateName.AmbassadorProject:
      return 'Increase brand awareness with long term partnerships.';
    case TemplateName.InfluencerCampaign:
      return 'Generate content in exchange for compensation.';
    case CustomProjectTemplateName:
      return 'Create a unique campaign for your own workflow.';
    default:
      return '';
  }
};

export const getCampaignIcon = (templateName: string) => {
  switch (templateName) {
    case TemplateName.ProductGifting:
      return <RocketIcon fontSize={16} />;
    case TemplateName.AmbassadorProject:
      return <MegaphoneIcon fontSize={16} />;
    case TemplateName.InfluencerCampaign:
      return <ImageIcon fontSize={16} />;
    case CustomProjectTemplateName:
      return <img src={aspireIcon} className="w-6 h-auto rounded-full" />;
    default:
      return null;
  }
};

export const getCampaignIconV2 = (templateName: string, size = 16) => {
  switch (templateName) {
    case TemplateName.ProductGifting:
      return <FontAwesomeIcon icon={faRocket} fontSize={size} />;
    case TemplateName.AmbassadorProject:
      return <FontAwesomeIcon icon={faBell} fontSize={size} />;
    case TemplateName.InfluencerCampaign:
      return <FontAwesomeIcon icon={faPhotoFilm} fontSize={size} />;
    case CustomProjectTemplateName:
      return <FontAwesomeIcon icon={faPaintbrush} fontSize={size} />;
    default:
      return null;
  }
};

export const getCampaignBgColor = (templateName: string) => {
  switch (templateName) {
    case TemplateName.ProductGifting:
      return 'bg-blue-4';
    case TemplateName.AmbassadorProject:
      return 'bg-purple-4';
    case TemplateName.InfluencerCampaign:
      return 'bg-teal-4';
    case CustomProjectTemplateName:
      return 'bg-yellow-4';
    default:
      return 'bg-white';
  }
};

export const hasWorkletsChanged = (worklets: TWorkletWithoutTypename[], contextWorklets: TWorkletWithoutTypename[]) => {
  if (worklets.length !== contextWorklets.length) {
    return true;
  }

  return worklets.some((worklet, index) => worklet.specKey !== contextWorklets[index].specKey);
};

export const getSpecIconAndBgColor = (workletSpecUri: string, size = 16) => {
  switch (workletSpecUri) {
    case WorkletSpecUri.SendTermsWorkletSpecification:
      return { icon: <FontAwesomeIcon icon={faEnvelope} fontSize={size} />, bgColor: 'bg-blue-3' };
    case WorkletSpecUri.PromoCodesWorkletSpecification:
      return { icon: <TagIcon fontSize={size} />, bgColor: 'bg-[#55B6B3]' };
    case WorkletSpecUri.ReviewContentWorkletSpecification:
      return { icon: <FontAwesomeIcon icon={faImage} fontSize={size} />, bgColor: 'bg-lime-4' };
    case WorkletSpecUri.ConfirmAddressWorkletSpecification:
      return { icon: <FontAwesomeIcon icon={faAddressCard} fontSize={size} />, bgColor: 'bg-purple-4' };
    case WorkletSpecUri.SalesLinkPromoCodesWorkletSpecification:
      return { icon: <FontAwesomeIcon icon={faTags} fontSize={size} />, bgColor: 'bg-purple-4' };
    case WorkletSpecUri.SalesLinkWorkletSpecification:
      return { icon: <LinkIcon fontSize={size} />, bgColor: 'bg-[#55B6B3]' };
    case WorkletSpecUri.CreatorProductSelectionWorkletSpecification:
    case WorkletSpecUri.SendBrandProductCatalogWorkletSpecification:
    case WorkletSpecUri.OfflineCreatorProductSelectionWorkletSpecification:
    case WorkletSpecUri.SendProductWorkletSpecification:
      return { icon: <FontAwesomeIcon icon={faSquareCheck} fontSize={size} />, bgColor: 'bg-yellow-5' };
    case WorkletSpecUri.SendContractWorkletSpecification:
      return { icon: <FileContractIcon fontSize={size} />, bgColor: 'bg-[#55B6B3]' };
    case WorkletSpecUri.PaymentWorkletSpecification:
      return { icon: <FontAwesomeIcon icon={faCircleDollarToSlot} fontSize={size} />, bgColor: 'bg-green-5' };
    case WorkletSpecUri.TrackPostsWorkletSpecification:
      return { icon: <FontAwesomeIcon icon={faCalendar} fontSize={size} />, bgColor: 'bg-teal-4' };
    default:
      return { icon: <BoxIcon fontSize={size} />, bgColor: 'bg-[#55B6B3]' };
  }
};

export const getCampaignIconName = (templateName: string): string => {
  switch (templateName) {
    case 'Product Launch':
      return 'rocket';
    case 'Ambassadors':
      return 'bell';
    case 'Influencer Content':
      return 'photo-film';
    case 'Custom Campaign':
      return 'paint-brush';
    default:
      return 'rocket';
  }
};
